import { Component, OnInit } from '@angular/core';
import { DataService, OptionsserviceService, UserService, OperationsService } from '../../_services/index';
import { LoansService, AuthenticationService, StorageService, CustomerService } from '../../_services/index';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-advancesearch',
  templateUrl: './advancesearch.component.html',
  styleUrls: ['./advancesearch.component.css']
})
export class AdvancesearchComponent implements OnInit {
  simpleSlider = { name: 'Simple Slider', onUpdate: undefined, onFinish: undefined };
  simpleSlider_ = { name: 'Simple Slider', onUpdate: undefined, onFinish: undefined };
  advancedSlider = { name: 'Advanced Slider', onUpdate: undefined, onFinish: undefined };
  min = 0;
  max = 100;
  min_ = 0;
  max_ = 1000000;
  filteringLoans = false;
  bureau_selected = '1';
  loan_: any;
  appKey = '';
  miniSearch = false;
  searchView = false;
  loading = false;
  currentUser: any;
  loans: any;
  overlayOpen = false;
  loan: any;
  request_id: any;
  overlayModalSection = '';
  simulateSection = 'default';
  isedit = '1';
  sub: any;
  public durations = [
    { display: '0 - 1', checked: false, min: 0, max: 30 },
    { display: '0 - 3', checked: false, min: 31, max: 90 },
    { display: '4 - 6', checked: false, min: 91, max: 180 },
    { display: '7 - 12', checked: false, min: 181, max: 365 },
    { display: '1+ Years', checked: false, min: 366, max: 3650 }
  ];
  public request_date = [
    { display: 'Today', checked: false, min: 0, max: 1 },
    { display: '2 - 7 days', checked: false, min: 2, max: 7 },
    { display: '2 - 4 weeks', checked: false, min: 8, max: 30 },
    { display: '1+ months', checked: false, min: 31, max: 100000 }
  ];
  public statuses = [
    // { value: '-2', display: 'All' },
    { value: '-6', display: 'Terminated' },
    { value: '-4', display: 'Disbursements' },
    { value: '5', display: 'Rejected' },
    { value: '-3', display: 'Ineligible' },
    { value: '6', display: 'Contract Created' },
  ];
  magic_filter = {
    repayment_status: '0',
    repayment_mode: '0',
    customer_category: '0',
    company_id: '',
    product_id:'',
    peer_to_peer: '',
    reset: false,
    my_approvals: false,
    account_officer: false,
    start: 0,
    funding: '100',
    token: '',
    min: 0,
    max: 10000000,
    loan_status: '1',
    searchText: '',
    ratings_one: false,
    ratings_two: false,
    ratings_three: false,
    ratings_four: false,
    ratings_five: false,
    funding_amount_one: 1,
    funding_amount_two: 1,
    funding_amount_three: false,
    funding_status_disbursement: false,
    funding_status_contract_created: false,
    funding_status_applied: false,
    funding_status_funded: false,
    funding_status: false,
    amount: false,
    approval_level: false,
    rating: false,
    sector: false,
    date: false
  };
  sectors: any;
  companies: any;
  approval_levels: any;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  cards = 'cards';
  accountdebit = 'accountdebit';
  open_approval = false;
  approving = false;
  rejecting = false;
  kyc_request = {
    KYC_COMMENTS: '',
    KYC_TYPE_ONE: false,
    KYC_TYPE_TWO: false,
    KYC_PACKAGE: ''
  }
  financials_request = {
    HOW_MANY_MONTHS: '',
    BANK_STATEMENTS: false,
    PAYSLIPS: false
  }
  guarantors_request = {
    HOW_MANY_GUARANTORS: '',
  }
  pickup = {
    KYC_COMMENTS: '',
    PICKUP_ADDRESS_TYPE: '1',
    CUSTOM_PICKUP_ADDRESS: '',
    PICKUP_PACKAGE: ''
  }
  rejection = {
    MESSAGE: '',
    SEND_REJECTION_MAIL: false
  }
  reopen = {
    MESSAGE: '',
    SEND_REOPEN_MAIL: false,
    SUSPEND_CUSTOMER: false,
    SUSPEND_FOR_HOW_LONG: '24'
  }
  public other_docs = [
    {
      'display': 'Valid ID Card',
      'value': '1',
      'checked': false
    },
    {
      'display': 'Other ID Card',
      'value': '15',
      'checked': false
    },
    {
      'display': 'Payslips',
      'value': '6',
      'checked': false
    },
    {
      'display': 'Bank Statements',
      'value': '7',
      'checked': false
    },
    {
      'display': 'Employment Letter',
      'value': '8',
      'checked': false
    },
    {
      'display': 'Purchase Order',
      'value': '9',
      'checked': false
    },
    {
      'display': 'Invoices',
      'value': '10',
      'checked': false
    },
    {
      'display': 'Certificate of Incorporation',
      'value': '11',
      'checked': false
    },
    {
      'display': 'Company Profile',
      'value': '12',
      'checked': false
    },
    {
      'display': 'Allotment of Shares',
      'value': '13',
      'checked': false
    },
    {
      'display': 'Particulars of Directors',
      'value': '14',
      'checked': false
    },
    {
      'display': 'Work ID Card',
      'value': '16',
      'checked': false
    },
    {
      'display': 'Utility Bill',
      'value': '17',
      'checked': false
    },
    {
      'display': 'National ID',
      'value': '18',
      'checked': false
    },
    {
      'display': 'Voter ID',
      'value': '19',
      'checked': false
    },
    {
      'display': 'International Passport',
      'value': '20',
      'checked': false
    },
    {
      'display': 'Offer Letter (Previous Loan)',
      'value': '21',
      'checked': false
    },
    {
      'display': 'Confirmation Letter',
      'value': '22',
      'checked': false
    },
  ]
  public bureaus = [
    {
      'display': 'CRC',
      'checked': true,
      'value': '1'
    },
    {
      'display': 'First Central(XDS)',
      'checked': false,
      'value': '2'
    },
    {
      'display': 'CRServices',
      'checked': false,
      'value': '3'
    }
  ]
  products:any;
  docpickups: any;
  doctypes: any;
  public level: any;
  public prev_levels: any;
  public model_r = { ilo: 0, reject_reason: '', reject_action: '', approval_notes: '', reject_level: '', wtd: 0, request_id: '', level: '' };
  public model_a = { chk_acts: [], past_one: 1, approval_all_waivers: 1, approval_all_checklist: 1, is_waiver_level: 0, has_waiver: 0, ilo: 0, istd: 0, approval_notes: '', wtd: 1, request_id: '', level: '' };
  disbursing_request = false;
  disburse: any;
  islarger = true;
  public is_done = '0';
  banks: any;
  childModal = { location: '', data: {} };
  account_for_direct_debit: any;
  overlayEditModalSection = '';
  nodes_and_scores: any;
  selected_analytics = '1';
  analytics_last_done = '';
  changingofficer = false;
  attachment_for_analysis: any;
  constructor(public storageService: StorageService, public optionsService: OptionsserviceService,
    public loansService: LoansService, private router: Router, private dataService: DataService,
    private authService: AuthenticationService, private customerService: CustomerService,
    private route: ActivatedRoute, private operationsService: OperationsService, private productService:ProductsService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    
  }
  ngOnInit() {
    if (this.storageService.read<any>('magic_filter')) { }
    this.optionsService.getOccupation(2).subscribe(sectors => this.sectors = sectors);
    this.optionsService.getCompanies(this.currentUser.token).subscribe(companies => this.companies = companies);
    this.productService.getLoanProducts(this.currentUser.token).subscribe(companies => this.products = companies);
    
    this.optionsService.getApprovalLevels(this.currentUser.token).subscribe(levels => this.approval_levels = levels);
  } 
  
  displayCondition(i) { 
    return true;
  }
  checkLevel(sector, event, index) {

    this.durations[index]['checked'] = event;

  }  
  onScrollDown(ev) {
    //this.loadMoreRecords(this.magic_filter.start)
  }
  closeChildModal() {
    this.childModal.location = '';
  } 
  getLoans() {
     
  }
  getLoans_() {
     
  }
  openSearchView() { }
  enter() { }
  leave() { }
  searchForLoans() {
    
  }    
   resetFilters() {
     this.filteringLoans = true;
    this.magic_filter.reset = true;
    this.getLoans();
  }
  update(slider, event) { 
    slider.onUpdate = event;
    this.magic_filter.min = event.from;
    this.magic_filter.max = event.to;
  }
  update_(slider, event) {
    this.magic_filter.funding = event.from;
  }
  update__(slider, event) {
    this.magic_filter.min = this.min_;
    this.magic_filter.max = event.from;
  }

}
